import useRestService from '../shared/rest-service';
import Navigation from '../models/navigation';

interface NewNavigation {
  name: string;
  link?: string;
  parentId?: number;
  seqOrder?: number;
}

/**
 * useNavigation
 * @function useNavigation - Custom hook for the navigation models
 */
const useNavigation = () => {
  const { getAuth, postAuth, putAuth, deleteAuth } = useRestService();

  /**
   * fetchNavigations
   * @function fetchNavigations - fetch complete navigation tree for a specified client
   * @param clientId Id of the active client
   */

  const fetchNavigations = (clientId: number): Promise<Navigation[]> => {
    return getAuth(`api/${clientId}/navigations`);
  };

  /**
   * updateNavigation
   * @function updateNavigation - update navigation object including any children navigation objects
   * @param clientId Id of the active client
   * @param data - Navigation object
   */
  const updateNavigations = (clientId: number, data: Navigation[]) => {
    return putAuth(`api/${clientId}/navigations/`, data);
  };

  /**
   * addNavigation
   * @function addNavigation - Create a single new top level navigation category with no children
   * @param clientId Id of the active client
   * @param name name of the new navigation category
   */
  const addNavigation = (clientId: number, data: NewNavigation) => {
    return postAuth(`api/${clientId}/navigations/`, data);
  };

  /**
   * deleteNavigation
   * @function deleteNavigation - delete a single navigation item
   * @param clientId Id of the active client
   * @param navigationId id of the navigation item to be deleted
   */
  const deleteNavigation = (clientId: number, navigationId: number) => {
    return deleteAuth(`api/${clientId}/navigations/${navigationId}`);
  };

  return {
    fetchNavigations,
    updateNavigations,
    addNavigation,
    deleteNavigation
  };
};

export { NewNavigation };
export default useNavigation;
